import {App} from "./app/app";

(function (win) {
    if (!window.BlueStackMediationTag) {
        window.BlueStackMediationTag = new App(win, false);
    }
})(window);